import { render, staticRenderFns } from "./question-tag.vue?vue&type=template&id=da7797b4"
import script from "./question-tag.js?vue&type=script&lang=js&external"
export * from "./question-tag.js?vue&type=script&lang=js&external"
import style0 from "./question-tag.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports